import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chaxun",
  "use": "icon-chaxun-usage",
  "viewBox": "0 0 19.173 19.171",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.173 19.171\" id=\"icon-chaxun\">\r\n  <g id=\"icon-chaxun_chaxun-2\" transform=\"translate(0 0)\">\r\n    <path id=\"icon-chaxun_路径_823\" data-name=\"路径 823\" d=\"M7.049,1.311a5.741,5.741,0,0,1,5.287,7.972,5.744,5.744,0,0,1-7.521,3.054,5.681,5.681,0,0,1-1.824-1.23,5.742,5.742,0,0,1-1.23-6.291,5.735,5.735,0,0,1,5.287-3.5M7.049,0A7.049,7.049,0,1,0,14.1,7.049,7.05,7.05,0,0,0,7.049,0Z\" fill=\"\" />\r\n    <path id=\"icon-chaxun_路径_824\" data-name=\"路径 824\" d=\"M120.562,111.961a6.248,6.248,0,0,1,.515-.461,5.262,5.262,0,0,0,.23,9.961,6.274,6.274,0,0,1-.745-9.5ZM134.114,128.1a1.654,1.654,0,0,1-2.331,0l-4.711-4.713a1.648,1.648,0,0,1,2.331-2.331l4.713,4.713A1.653,1.653,0,0,1,134.114,128.1Z\" transform=\"translate(-115.423 -109.412)\" fill=\"\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chaxun.svg
// module id = ManV
// module chunks = 69